import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";

const LocaleDropdownLabel = ({ className, ...props }: ComponentPropsWithoutRef<"span">) => {
    return <span {...props} className={clsx(className, "ml-2.5 truncate first:ml-0 sm:ml-2 sm:first:ml-0")} />;
};

export default LocaleDropdownLabel;
